jQuery( document ).ready(function() {
    jQuery('#Slider-template--15322109837478__1642607527967bd1de').slick({
      dots: true,
      infinite: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            dots: true
          }
        },{
          breakpoint: 989,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }
      ]
    });
    jQuery('.blog .blog__posts').slick({
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: false,
      nextArrow: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }
      ]
    });
    jQuery('.our-brands-wrapper').slick({
      dots: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplay: true,
  			autoplaySpeed: 2000,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            autoplay: true,
  			autoplaySpeed: 2000,
          }
        }
      ]
    });
    jQuery('.hero-section .hero-wrapper').slick({
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
    });
  
  $('.list-tabs .tab-title a').on('click',function(e){
    e.preventDefault();
    var tabid = $(this).attr('data-target');
    $(this).closest('.list-tabs').find('.tab-title a.active').removeClass('active');
    $('.wrapper-tab-content .tab-content.active').removeClass('active');
    $('.wrapper-tab-content .tab-content[id="'+tabid+'"]').addClass('active');
    $(this).addClass('active');
  });
  
  if($(window).width() <= 749){
    $('.tab-title a').on('click',function(){
      var title = $(this).attr('data-target');
      $(this).toggleClass("active");
      $('.tab-content[id="'+title+'"]').slideToggle();
    });
  }
  $('.product-main-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: true,
    asNavFor: '.product-thumbnail-images'
  });
  $('.product-thumbnail-images').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product-main-image',
    dots: false,
    infinite: true,
    focusOnSelect: true,
    responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
  ]
  });
});
/* Sticky Add-to-Cart bar */
(function(){
  var bar = document.getElementById('tsStickyAtc');
  var mainBtn = document.querySelector('.product-form__submit');
  if(!bar || !mainBtn) return;
  var stickyBtn = document.getElementById('tsStickyBtn');
  if(stickyBtn){ stickyBtn.addEventListener('click', function(e){ e.preventDefault(); mainBtn.click(); }); }
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var above = en.boundingClientRect.top < 0;
        if(!en.isIntersecting && above){ bar.classList.add('is-visible'); }
        else { bar.classList.remove('is-visible'); }
      });
    }, { threshold: 0 });
    io.observe(mainBtn);
  }
})();

/* ===== TS Compare (products) ===== */
(function(){
  var KEY='tsCompare', MAX=4, bar, modal;
  function load(){ try{ return JSON.parse(localStorage.getItem(KEY))||[]; }catch(e){ return []; } }
  function save(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  function has(a,id){ return a.some(function(p){ return p.id===id; }); }
  function esc(s){ return (s==null?'':String(s)).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function fromCb(cb){ return { id:cb.getAttribute('data-id'), title:cb.getAttribute('data-title'), url:cb.getAttribute('data-url'), img:cb.getAttribute('data-img'), price:cb.getAttribute('data-price'), compare:cb.getAttribute('data-compare'), cap:cb.getAttribute('data-cap'), out:cb.getAttribute('data-out'), ports:cb.getAttribute('data-ports'), feat:cb.getAttribute('data-feat'), avail:cb.getAttribute('data-avail') }; }
  function ensureUI(){
    if(!bar){ bar=document.createElement('div'); bar.className='ts-cmp-bar'; document.body.appendChild(bar); }
    if(!modal){
      modal=document.createElement('div'); modal.className='ts-cmp-modal';
      modal.innerHTML='<div class="ts-cmp-backdrop"></div><div class="ts-cmp-dialog"><button class="ts-cmp-close" aria-label="Close">&times;</button><div class="ts-cmp-head">Compare products</div><div class="ts-cmp-scroll"></div></div>';
      document.body.appendChild(modal);
      modal.querySelector('.ts-cmp-backdrop').addEventListener('click', closeModal);
      modal.querySelector('.ts-cmp-close').addEventListener('click', closeModal);
    }
  }
  function renderBar(){
    var a=load(); ensureUI();
    if(!a.length){ bar.classList.remove('show'); return; }
    bar.innerHTML='<div class="ts-cmp-bar-in"><div class="ts-cmp-thumbs">'+a.map(function(p){ return '<span class="ts-cmp-thumb"><img src="'+p.img+'" alt=""><button data-rm="'+p.id+'" aria-label="Remove">&times;</button></span>'; }).join('')+'</div><div class="ts-cmp-actions"><button class="ts-cmp-clear">Clear</button><button class="ts-cmp-go">Compare ('+a.length+')</button></div></div>';
    bar.classList.add('show');
    bar.querySelectorAll('[data-rm]').forEach(function(b){ b.addEventListener('click', function(){ removeId(b.getAttribute('data-rm')); }); });
    bar.querySelector('.ts-cmp-clear').addEventListener('click', clearAll);
    bar.querySelector('.ts-cmp-go').addEventListener('click', openModal);
  }
  function removeId(id){
    save(load().filter(function(p){ return p.id!==id; }));
    var cb=document.querySelector('.ts-compare-cb[data-id="'+id+'"]'); if(cb) cb.checked=false;
    renderBar();
    if(modal && modal.classList.contains('show')){ if(load().length) buildTable(); else closeModal(); }
  }
  function clearAll(){ save([]); document.querySelectorAll('.ts-compare-cb').forEach(function(cb){ cb.checked=false; }); renderBar(); closeModal(); }
  function onChange(cb){
    var a=load(), id=cb.getAttribute('data-id');
    if(cb.checked){
      if(has(a,id)) return;
      if(a.length>=MAX){ cb.checked=false; alert('You can compare up to '+MAX+' products at once.'); return; }
      a.push(fromCb(cb)); save(a);
    } else { a=a.filter(function(p){ return p.id!==id; }); save(a); }
    renderBar();
    if(modal && modal.classList.contains('show')) buildTable();
  }
  function buildTable(){
    var a=load(); if(!a.length) return;
    var rows=[{k:'cap',l:'Capacity'},{k:'out',l:'Output'},{k:'ports',l:'Ports'},{k:'feat',l:'Key features'},{k:'avail',l:'Availability'}];
    var html='<table class="ts-cmp-table"><tbody>';
    html+='<tr class="ts-cmp-hrow"><th class="ts-cmp-rowlab"></th>'+a.map(function(p){ return '<td><button class="ts-cmp-col-rm" data-rm="'+p.id+'" aria-label="Remove">&times;</button><a href="'+p.url+'" class="ts-cmp-col-img"><img src="'+p.img+'" alt=""></a><a href="'+p.url+'" class="ts-cmp-col-title">'+esc(p.title)+'</a></td>'; }).join('')+'</tr>';
    html+='<tr class="ts-cmp-pricerow"><th class="ts-cmp-rowlab">Price</th>'+a.map(function(p){ return '<td><b>'+esc(p.price||'')+'</b>'+(p.compare?' <s>'+esc(p.compare)+'</s>':'')+'</td>'; }).join('')+'</tr>';
    rows.forEach(function(r){
      var any=a.some(function(p){ return p[r.k] && p[r.k].trim(); });
      if(!any) return;
      html+='<tr><th class="ts-cmp-rowlab">'+r.l+'</th>'+a.map(function(p){ var v=p[r.k]&&p[r.k].trim()?esc(p[r.k]):'<span class="ts-cmp-dash">&mdash;</span>'; return '<td>'+v+'</td>'; }).join('')+'</tr>';
    });
    html+='<tr class="ts-cmp-actrow"><th class="ts-cmp-rowlab"></th>'+a.map(function(p){ return '<td><a href="'+p.url+'" class="ts-cmp-view">View product</a></td>'; }).join('')+'</tr>';
    html+='</tbody></table>';
    modal.querySelector('.ts-cmp-scroll').innerHTML=html;
    modal.querySelectorAll('.ts-cmp-col-rm').forEach(function(b){ b.addEventListener('click', function(){ removeId(b.getAttribute('data-rm')); }); });
  }
  function openModal(){ ensureUI(); buildTable(); modal.classList.add('show'); document.documentElement.style.overflow='hidden'; }
  function closeModal(){ if(modal){ modal.classList.remove('show'); document.documentElement.style.overflow=''; } }
  function initCheckboxes(){
    var a=load();
    document.querySelectorAll('.ts-compare-cb').forEach(function(cb){
      if(cb.dataset.tsBound) return; cb.dataset.tsBound='1';
      if(has(a, cb.getAttribute('data-id'))) cb.checked=true;
      cb.addEventListener('change', function(){ onChange(cb); });
    });
  }
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeModal(); });
  function boot(){ initCheckboxes(); renderBar(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  var t; new MutationObserver(function(){ clearTimeout(t); t=setTimeout(initCheckboxes, 250); }).observe(document.body,{childList:true,subtree:true});
})();
